import { render, staticRenderFns } from "./filter.vue?vue&type=template&id=28192df9&scoped=true&lang=true&"
import script from "./filter.vue?vue&type=script&lang=js&"
export * from "./filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28192df9",
  null
  
)

export default component.exports